<ng-container *ngIf="show">
  <div class="outside-area" @fade (click)="onClickOutside($event)"></div>

  <tui-scrollbar class="sidebar" @tuiSlideInRight>
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </tui-scrollbar>
</ng-container>
